module.exports = __webpack_public_path__ + "static/media/Acc-1b.f2d8682a.png";